module.exports = __webpack_public_path__ + "static/our-partners-crop-c8e508d0dd01be70f444d4aec7271424.jpg";